import type { GivenNameExactness, SurnameExactness } from "@searchui-searchforms/shared/canonicalizer";
import type { FormMetadataResponse } from "@searchui-searchforms/shared/form-metadata";
import { getRequiredNameFields } from "./getRequiredNameFields";

interface NameExactnessValues {
    givenName: string;
    surname: string;
    givenNameExactness: GivenNameExactness;
    surnameExactness: SurnameExactness;
}

export interface PersistableNameExactness {
    givenNameExactness?: GivenNameExactness;
    surnameExactness?: SurnameExactness;
}

/**
 * Returns the subset of name exactness values that may be persisted to the user's saved search
 * preferences. A name exactness is persistable only when the field has a value AND is not locked by
 * the collection (required-for-search). A locked field's exactness is forced to "Exact" by the
 * collection, not chosen by the user, so persisting it would leak the forced value onto every other
 * collection. See TT-3965.
 */
export const getPersistableNameExactness = (
    name: NameExactnessValues,
    formMetadata: FormMetadataResponse,
): PersistableNameExactness => {
    const required = getRequiredNameFields(formMetadata);

    return {
        ...(name.givenName && !required.givenName && { givenNameExactness: name.givenNameExactness }),
        ...(name.surname && !required.surname && { surnameExactness: name.surnameExactness }),
    };
};
